module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-business-description_pc-7d196d2457a697d77f0364b70559f0b7.svg";